import generateBlogPostingSchemaOrgData from 'src/helpers/generateBlogPostingSchemaOrgData';
import generateSchemaOrgCommonValues from 'src/helpers/generateSchemaOrgCommonValues';
import { computed } from 'vue';
import { useRenderStore } from 'stores/render';

export default () => {
  const renderStore = useRenderStore();
  const {
    publicHostUrl,
    logo,
    context,
    name,
  } = generateSchemaOrgCommonValues(renderStore.settings);

  return computed(() => ({
      '@context': context,
      '@type': 'Blog',
      '@id': publicHostUrl,
      mainEntityOfPage: publicHostUrl,
      name,
      description: renderStore.settings.metaFields.metaDescription,
      publisher: {
        '@type': 'Organization',
        '@id': publicHostUrl,
        name,
        logo,
      },
      blogPost: renderStore.posts
        ? renderStore.posts.map((post) => generateBlogPostingSchemaOrgData(post, publicHostUrl))
        : [],
    }));
};
